// src/theme/styles.ts
// Shared glassmorphism styles for consistent UI design

export const glassStyle = {
  bg: "rgba(255, 255, 255, 0.1)",
  backdropFilter: "blur(10px)",
  border: "1px solid rgba(255, 255, 255, 0.2)",
  borderRadius: "xl",
  boxShadow: "xl",
};

// Light mode variant for better visibility on light backgrounds
export const glassStyleLight = {
  bg: "whiteAlpha.800",
  backdropFilter: "blur(10px)",
  border: "1px solid",
  borderColor: "whiteAlpha.400",
  borderRadius: "xl",
  boxShadow: "xl",
};

// Dark mode variant for better visibility on dark backgrounds
export const glassStyleDark = {
  bg: "blackAlpha.600",
  backdropFilter: "blur(10px)",
  border: "1px solid",
  borderColor: "whiteAlpha.200",
  borderRadius: "xl",
  boxShadow: "xl",
};

